import {apiActionsCountries} from "../constants/ApiMiddlewareConstants";
import API from "../../../common/utils/API";
import {
    fetchAllCountries,
    fetchAllCountriesSuccess,
    fetchCountryDetailSuccess
} from "../../../veritas/country-coverage/actions/CountriesActions";
import {activityLoggerActionTypes} from "../constants/UtilityMiddlewareConstants";
import MARVEL from "../../../common/utils/MarvelUrls";
import { setRouterLink } from "../../../router/RouterActions";
import {toggleCountryModal, updatedCountryRefresh} from "../../../veritas/add-edit/actions/AddEditCountryActions";
import {toUpperCaseSentence} from "../../../common/utils/ToUpperCaseSentence";
import {displayDuplicateMessage, displayErrorMessage} from "../../../common/marvel-reducers/formMessageActions";

/**
 * This is the Middleware to handle the API calls pertaining to
 * Countries. (Currently, only contains logic for get all
 * ... rest will be added subsequently.)
 * @param store, action
 * @returns Makes the API call and conditionally dispatches logger actions or
 * error or warning messages.
 */
const apiMiddlewareCountries = (store) => (next) => (action) => {

    switch (action.type) {

        case apiActionsCountries.GET_ALL_COUNTRIES: {
            next(action);

            const {authToken} = action.payload;
            API.getCountries(authToken.idToken)
                .then(res => {
                    store.dispatch(fetchAllCountriesSuccess(res.data))
                })
                .catch(error => {
                    console.error(error);
                    throw error;
                })
            break;
        }

        case apiActionsCountries.GET: {
            next(action);

            const {countryID, authToken} = action.payload;
            API.getOneCountry(countryID, authToken.idToken)
                .then(res => {
                    store.dispatch(fetchCountryDetailSuccess(res.data))
                })
                .catch(error => {
                    console.error(error);
                })

            break;
        }

        case apiActionsCountries.PUT:{
            next(action);

            const { countryID, countryObj, authToken } = action.payload;
            API.putOneCountry(countryID, countryObj, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.id,
                        object_type: "country_edit",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: { log, authToken }
                    });
                    store.dispatch(toggleCountryModal());
                    store.dispatch(updatedCountryRefresh());
                })
                .catch(error => {
                    const message = [];
                    const errorObj = error.response.data
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObj)) {
                        message.push(toUpperCaseSentence(value[0]));
                    }
                    store.dispatch(displayErrorMessage(message, true));
                })

            break;
        }

        case apiActionsCountries.POST:{
            next(action);

            const { countryObj, authToken } = action.payload;
            API.postOneCountry(countryObj, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.id,
                        object_type: "country_create",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: { log, authToken }
                    });
                    store.dispatch(toggleCountryModal());
                    store.dispatch(fetchAllCountries());
                    store.dispatch(setRouterLink(MARVEL.VERITAS.country_coverage + res.data.id))

                })
                .catch(error => {
                    const errorObj = error.response.data
                    const message = [];
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObj)) {
                        message.push(toUpperCaseSentence(value));
                    }
                    if (errorObj['country_name']) {
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                        store.dispatch(displayErrorMessage(message, true));
                    }
                });

            break;
        }

        case apiActionsCountries.DELETE: {
            next(action);

            const {countryID, authToken} = action.payload;
            API.deleteOneCountry(countryID, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: countryID,
                        object_type: "country_delete",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(fetchAllCountries())
                    store.dispatch(setRouterLink(MARVEL.VERITAS.country_coverage))

                })
                .catch(error => {
                    console.error(error);
                })

            break;
        }

        default: next(action);
    }
}

export default apiMiddlewareCountries;
